const convertButtonType = (type) => {
    if(type === 'button_round'){
        return 'rounded'
    }else if(type === 'button_rounder'){
        return 'rounder'
    }else if(type === 'button_square'){
        return 'square'
    }else{
        return 'square'
    }
}
export {
    convertButtonType
}
export default {
    convertButtonType,
}